import { ContractCreateButtonConfig } from "../contract/components/contract-create-button";

export const omniContractCreateButtonConfig: ContractCreateButtonConfig = {
  selectBaseData: false,
};
